// Copyright 2019 Stanford University see LICENSE for license

export const selectExports = (state) => state.entities.exports

export const hasExports = (state) => state.entities.exports.length > 0
